import React from 'react';

const Footer = () => {
  return (
    <div id="contact" className="footer">
      <div>
        <a href="mailto:itsritzw@gmail.com">
          <i className="fa fa-envelope-o" aria-hidden="true" />
        </a>
        <a href="https://www.linkedin.com/in/yufengritz">
          <i className="fa fa-linkedin-square" aria-hidden="true" />
        </a>
        <a href="https://www.instagram.com/awwmeoooow">
          <i className="fa fa-instagram" aria-hidden="true" />
        </a>
      </div>
      <div>
        <span>
          <i className="fa fa-copyright" aria-hidden="true" />
          {new Date().getFullYear()} Ritz Yufeng Wang
        </span>
      </div>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/Modules/Home/Footer.js